// extracted by mini-css-extract-plugin
module.exports = {"text":"termsPage_text__XnyTl"};